import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AssetFinanceSummary } from '@portal-workspace/grow-shared-library';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { booleanToYesNo, displaybleDate, notNullUndefined, SummaryEntityValue } from '@portal-workspace/grow-shared-library';
import { summaryEntityParties } from '@portal-workspace/grow-ui-library';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { CellComponent } from './cell.component';
import { ContactsSummaryComponent } from './contacts-summary.component';
import { EntitiesSummaryComponent } from './entities-summary.component';
import { ReferencesSummaryComponent } from './references-summary.component';
import { CommonModule } from '@angular/common';
import { LoanPurposeSummaryComponent } from '../loan-purpose-summary/loan-purpose-summary.component';
import { EllipsisPipe } from "../../pipes/ellipsis.pipe";

@Component({
    selector: 'asset-finance-summary',
    templateUrl: './asset-finance-summary.component.html',
    styleUrls: ['./asset-finance-summary.component.scss'],
    standalone: true,
    imports: [LoanPurposeSummaryComponent, MatFormFieldModule, MatInputModule, FormsModule, CellComponent, MatDividerModule, ContactsSummaryComponent, EntitiesSummaryComponent, ReferencesSummaryComponent, LooseCurrencyPipe, EllipsisPipe,CommonModule]
})
export class AssetFinanceSummaryComponent implements OnInit,OnChanges {

  booleanToYesNo = booleanToYesNo;
  displayableDate = displaybleDate;
  notNullUndefined = notNullUndefined;

  _entities?: SummaryEntityValue[];

  @Input({required: true}) summary!: AssetFinanceSummary;

  ngOnInit(): void {
  }
  ngOnChanges(){
    this._entities = summaryEntityParties(this.summary?.applicants, this.summary?.guarantors);
  }

}
